module.exports = __webpack_public_path__ + "img/getboarded-logo.59846453.svg";